/**
 * The power of the IMR factor.
 * @constant
 * @default
 */
export const IMRFactorPower = 4 / 5;
